export default "__VITE_ASSET__BxT$0UnM__"